/** Nazwa pliku z nagłówka `Content-Disposition`, albo `fallback`, gdy jej brak. */
export function filenameFromDisposition(disposition: string | null, fallback: string): string {
  const match = /filename="?([^";]+)"?/.exec(disposition ?? '')
  return match?.[1] ?? fallback
}

/** Zapisuje pobrany blob na dysku użytkownika przez tymczasowy link. */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  URL.revokeObjectURL(url)
}
